<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import moment from "moment";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import MaskedInput from "vue-text-mask";
import Vue from "vue";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.use(Toasted);
/**
 * new orden component
 */
export default {
  page: {
    title: "Asignacion Gestacion",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Vuetable,
    VuetablePagination,
    // DatePicker,
    Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // "masked-input": MaskedInput,
  },
  data() {
    return {
      loteId :   this.$route.params.idlote,
      animalesNuevosT:0,
      arrayLotes:[],
      arrayLote:[],
      userT: this.$store.state.authfack.user,
      totalAnimalesLoteR:0,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      apiBase:
        process.env.VUE_APP_URL +  "lote_animal/findByIdLoteAnimalActives?id=" + this.loteId+'&descarte='+true,
      saldo: 0,
      // Variables para metodos de pago
      cantidad_efectivo: "",
   
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      fecha_traslado : '',
      fecha_posible_parto:'',
      // variables para detalle
      cabezera: [
        
      { key: 'index', label: 'Índice' },
        { key: "codigo", label: "Codigo", thClass: "cell1" },
        { key: "raza", label: "Raza", thClass: "cell1" },
        { key: "fecha_ingreso", label: "Fecha Ingreso", thClass: "cell1" }
        
      ],
      apiUrl: process.env.VUE_APP_URL,
      fieldsBusqueda: [{
            name: "actions",
            title: "Acciones",
            titleClass: "",
            width: "10%",
            },
            {
            name: "cerdo.codigo",
            title: "Código",
            sortField: "cerdo.codigo",
            width: "20%",
            },
            {
            name: "cerdo.raza",
            title: "Raza",
            sortField: "cerdo.raza",
            width: "20%",
            },
            {
            name: "fecha_entrada",
            title: "Fecha Ingreso",
            sortField: "fecha_entrada",
            width: "20%",
            },
        ],
      fields: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
        {
          name: "codigo",
          title: "Código",
          sortField: "codigo",
          width: "20%",
        },
        {
          name: "raza",
          title: "Raza",
          sortField: "raza",
          width: "20%",
        }
      ],
      formPro: {
        fecha_limite: new Date(),
        loteid: -1,
        metodo_pago: "0",
        loteidrecibe : -1,
        lote_recibe : null,
        factura: "",
        fecha_compra: new Date(),
        fecha_entrega: new Date(),
        tiendaid: "",
        tienda: "",
        orden: "",
        lote: "",
        total: "",
        state: true,
        observaciones : "",
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "Traslado de Gestacion",
      items: [
        {
          text: "Corrales",
          href: "/",
        },
        {
          text: "Corrales",
          active: true,
        },
      ],
      searchType: [
        { nombre: "Codigo", value: "codigo" },
        // { nombre: "Codigo", value: "codigo" },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,
      searchLabel: { nombre: "Codigo", value: "producto" },
      filterLabel: { nombre: "Codigo", value: "producto" },
      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      tipo_lote: '',
      total: 0,
      lastPage: 0,
      arrayDetalle: [],
      LotesExist:'',
      totalAnimalesActuales: 0,
      arrayLotesRecibe:[],
      arrayAnimalSalida:[],
      costos_inseminacion: 0,
    };
  },
  validations: {
    formPro: {
      lote: { required },
      lote_recibe: { required },
      factura: { required },
      fecha_entrega: { required },
      fecha_compra: { required },
      fecha_limite: { required },
      tienda: { required },
      orden: { required },
      total: { required },
    },
    costos_inseminacion: { required },
    arrayDetalle: {
      required,
      $each: {
        cantidad: {
          required,
        },
        ubicacion: {
          required,
        },
      },
    },
    data: { required },

  },
  async mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    // this.getCerdosLoteSalida(this.loteId, this.page, this.search);
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
      

      return this.arrayDetalle.length + parseInt( this.totalAnimalesActuales );
    },
    calcularTotalNuevos: function () {
      return this.arrayDetalle.length;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // PROVEEDORES
   

    selectLote(search, loading){
                let me = this;
                loading(true);
                let url =  process.env.VUE_APP_URL + '/lotes/select_lote?filtro=' + search + '&tipo_lote=Descarte';
                axios.get(url,{
                    headers: { "x-token": this.userT.token },
                }).then(function (response) {
                    // console.log(response);
                    me.arrayLotes = response.data.data.data;
                    loading(false);
                })
                .catch(function (error) {
                    console.log({error});
                });
    },
    getDatosLotesRecibe(val1){
        let me = this;
        me.loading = true;
        if (val1 == null || val1 == ''){
            me.formPro.lote_recibe = '';
            me.formPro.loteidrecibe = -1;
        }
        else {
            me.formPro.loteidrecibe = val1.id;
            
            me.totalAnimalesActuales = val1.no_animales;
            // console.log(    val1);
        }
    },
    selectLoteRecibe(search, loading){
                let me = this;
                loading(true);
                let url =  process.env.VUE_APP_URL + '/lotes/select_lote?filtro=' + search + '&tipo_lote=' + "Descarte"  + '&id=' + me.loteId;
                axios.get(url,{
                    headers: { "x-token": this.userT.token },
                }).then(function (response) {
                    // console.log(response);
                    me.arrayLotesRecibe = response.data.data.data;

                    loading(false);
                })
                .catch(function (error) {
                    console.log({error});
                });
    },
    getbyCerdoRecibe(id){
        // console.log(id, 'esta entrando')
      let url =  process.env.VUE_APP_URL + '/lotes/getByCerdoMadreReacomodo?id=' + id;
      axios.get(url,{
          headers: { "x-token": this.userT.token },
      }).then(function (response) {
          console.log(response);

      })
      .catch(function (error) {
          console.log({error});
      });
    },
    tomandototal() {
      let temp = 0;
      temp = parseFloat(this.calcularTotal);
      this.formPro.total = temp;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    //Validaciones antes de guardar
    validaciones() {
      // stop here if form is invalid
      this.$v.$touch();
      // console.log(this.formPro.proveedor);
    //   console.log(this.formPro.loteid);
      if (
        this.formPro.loteidrecibe <=0
      ) {
        // console.log("retroll");
        Vue.toasted.error("Revise la cabecera de la asignancio ", this.options);
        return;
      } 
      else if(this.arrayDetalle.length <=0){
        Vue.toasted.error("Agregue Detalles a la asignancio ", this.options);
        return;
      }
      
      else {
  
          this.save();
        }
      
    },
    //Guardar registro
    async save() {
      const me = this;
      this.showModalL = true;
      axios
        .post(
          process.env.VUE_APP_URL + "lote_animal/store_descarte",
          {
            idEnvia : me.loteId,
            idRecibe : me.formPro.loteidrecibe ,
            total_animales : me.arrayDetalle.length,
            userId:this.userT.id,
            cerdoId : me.arrayDetalle[0].id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Registro Guardado", this.options);
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
          this.$router.push({
            name: 'vista_lote',
            params: { id: this.loteId },
            shallow: true,
          });
        });
    },
    // Funciones para trabajar con detalles

    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Funciones para formatos
   
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
  
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    eliminarDetalle(index) {
      this.arrayDetalle.splice(index, 1);
    },
    agregarDetalle(data) {
      // console.log(data);
      const {id,  codigo, raza, semanas, estado_animal, partos} = data.cerdo;
      const {fecha_entrada} = data;

      const me = this;

      if(me.encuentra(id)){
            Vue.toasted.error("El producto seleccionado ya se encuentra en el detalle", this.options);
          }else{
            if(me.arrayDetalle.length == 0){
                me.arrayDetalle.push({
                    id, fecha_ingreso : fecha_entrada, codigo, raza, semanas, estado_animal, partos,
                    peso: 0,
                });
            }else{
                Vue.toasted.error("Unicamente se puede agregar un animal x lote", this.options);
            }

          } 
    },
    verificaAnimal(stock) {
      const me = this;
    //   console.log(stock)
      if (me.encuentra(stock.cerdo.id)) {
        return true;
      }
    },
    sumarDias(dias) {
    // Crear una nueva instancia de la fecha para evitar modificar el original
    let nuevaFecha = new Date();
    // Sumar los días
    nuevaFecha.setDate(nuevaFecha.getDate() + dias);
    return nuevaFecha;
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id == id) {
          sw = true;
        }
      }
      return sw;
    },


    //Buscador dentro de la tabala
    async onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    async changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    async changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            id : this.loteId
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            id : this.loteId
          };
    },
  },
};
</script>

<template>
  <Layout>
    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row">
                <div class="col-">
                  <div class="row">
                    <div class="col">
                      <h4>Datos Generales</h4>
                    </div>
                    <div class="col" align="center">
                      <div class="mt-4 mt-sm-0">
                        <p class="text-muted mb-2">Total Animales</p>
                        <h3>
                          {{
                            
                              formPro.total > 0 ? formPro.total : 0.0
                            
                          }}
                        </h3>
                      </div>
                      
                    </div>
                    <div class="col" align="center">
                      <div class="mt-4 mt-sm-0">
                        <p class="text-muted mb-2">Total Animales Nuevos</p>
                        <h3>
                          {{
                            
                            calcularTotalNuevos
                            
                          }}
                        </h3>
                      </div>  
                    </div>

                    <div class="col" align="right">
                      <div>
                        <router-link
                        :to="{
                            name: 'vista_lote',
                            params: { id: loteId },
                          }"
                        >
                          <b-button
                            variant="outline-primary"
                            type="button"
                            class="btn btn-rounded mb-2 me-2"
                          >
                            <i class="mdi mdi-arrow-collapse-left"></i> Regresar
                          </b-button>
                        </router-link>
                      </div>
                    </div>
                  </div>

                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-3">
                        <div>
                        <p class="text-muted mb-2">Lote Recibe</p>
                        <v-select
                          v-model.trim="$v.formPro.lote_recibe.$model"
                          :state="!$v.formPro.lote_recibe.$error"
                          :options="arrayLotesRecibe"
                          @search="selectLoteRecibe"
                            @input="getDatosLotesRecibe"
                          placeholder="Buscar Lote..."
                          label="nombre"
                        >
                        </v-select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formPro.lote_recibe.$error &&
                              !$v.formPro.lote_recibe.required,
                          }"
                        >
                          Debe seleccionar un Lote
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <Loader :loading="loadingtable">
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="p-3 text-muted"
      >
      <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <h5><i class="bx bxs-folder-plus"></i></h5>
          </span>
          <h5>
            <span class="d-none d-sm-inline-block">
              <i class="bx bxs-folder-plus"></i>Seleccionar Animales</span
            >
          </h5>
        </template>
        <div class="row">
          <div class="col-12">
            <Loader :loading="loadingtable">
              <div class="row mt-4">
                <div class="col-sm-12 col-md-2">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Mostrar&nbsp;
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-2">
                  
                </div>
                <div class="col-sm-12 col-md-2">
                  <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      <b-dropdown v-if="searchType" id="ddown1" size="sm">
                        <template v-slot:button-content>
                          {{ "Buscar por: " + searchLabel.nombre }}
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="changeTypeSearch(search)"
                          >{{ search.nombre }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 text-md-start">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        v-model="search"
                        type="search"
                        @input="onFiltered()"
                        placeholder="Buscar..."
                        class="form-control form-control-sm"
                      ></b-form-input>
                    </label>
                  </div>
                </div>

                <div class="col-sm-12 col-md-5">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  ></div>
                </div>

                <!-- End search -->
              </div>
              <vuetable
                small
                striped
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :http-options="httpOptions"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fieldsBusqueda"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div
                  slot="actions"
                  slot-scope="props"
                  v-if="verificaAnimal(props.rowData) != true"
                >
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Agregar"
                      variant="outline-primary"
                      @click="agregarDetalle(props.rowData)"
                      ><i class="bx bx-check"></i>
                    </b-button>
                  </b-button-group>
                </div>
                <div slot="fecha_entrada" slot-scope="props">
                  {{customFormatter(props.rowData.fecha_entrada)}}
                </div>

              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </b-tab>
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <h5><i class="bx bxs-food-menu"></i></h5>
            </span>
            <h5>
              <span class="d-none d-sm-inline-block">
                <i class="bx bxs-food-menu"></i>Asignar detalles</span
              >
            </h5>
          </template>

          <b-table
          small
          striped
            responsive
            v-if="arrayDetalle.length > 0"
            ref="table"
            :items="arrayDetalle"
            :fields="cabezera"
          >
          <template #cell(index)="data">
              
              <b-button-group>
                <b-button
                    size="md"
                    variant="outline-danger"
                    @click="eliminarDetalle(data.index)"
                ><i :class="'bx bx-trash'"
                /></b-button>
              </b-button-group>
            </template>
            <template #cell(codigo)="data">
              {{ data.item.codigo }}
            </template>
            <template #cell(raza)="data">
              {{ data.item.raza }}
            </template>
            <template #cell(fecha_ingreso)="data">
              {{ data.item.fecha_ingreso }}
            </template>
            <template #cell(partos)="data">
              {{ data.item.partos }}
            </template>
          </b-table>
          <!-- <div class="row">
            <div class="col-12">
              <div v-if="$v.arrayDetalle.$error">
                <div class="alert alert-danger">Debe ingresar detalles</div>
              </div>
            </div>
          </div> -->
        </b-tab>
      </b-tabs>

      <div class="col-sm-12 pt-3">
        <div class="row">
          <div class="col">
            <router-link
              class="d-grid gap-2"
              :to="{
                name: 'vista_lote',
                params: { id: loteId },
              }"
            >
              <b-button
                block
                size="lg"
                variant="outline-primary"
                type="button"
                class="btn btn-rounded mb-2 me-2"
              >
                <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b>REGRESAR</b>
              </b-button>
            </router-link>
          </div>
          <div class="col d-grid gap-2">
            <b-button
              block
              size="lg"
              variant="outline-success"
              class="btn btn-rounded mb-2 me-2"
              @click="validaciones('save')"
            >
              {{ tomandototal() }}
              <i class="mdi mdi-truck-fast me-1"></i>
              &nbsp;&nbsp;<b>GUARDAR</b>
            </b-button>
          </div>
        </div>
      </div>
    </Loader>
    <!-- end row -->
  </Layout>
</template>
